import { Scene, Input, Math as MathPhaser } from "phaser";
import {
    backStaticAnimation, leftStaticAnimation, lightstickAnimation, mapHandler, reposeAnimation,
    rightStaticAnimation, turnStaticAnimation, upStaticAnimation, walkAnimation
} from '../../phaser/create';
import { walkHandler, randomDirection, setLastMovement } from '../../phaser/update';
import FullScreen from "../../phaser/components/fullScreen";
import PauseButton from "../../phaser/components/pauseButton";
import LightstickCounter from "../../phaser/components/lightstickCounter";
import ButtonPressed from "../../phaser/components/buttonPressed";
import SettingsButton from "../../phaser/components/settingsButton";
import HelpButton from "../../phaser/components/helpButton";
import Joystick from "../../phaser/components/joystick";

let cursors;
let walls;
let instructionsHandler = 0;

let characterSelected;
let objNames = {};
let timeoutDoor = {};
let footsteps;
let speedEnemy = 200;
let hearts = 1;
let totalHearts = 1;
let redHeartsObject = [];
let blackHeartsObject = [];
let gameSettings;
let defaultSettings = 1;
let lastCoordenates = null;

const randomPointsEnemy = [
    { x: 1018, y: 234 },
    { x: 2056, y: 791 },
    { x: 2755, y: 895 },
    { x: 2076, y: 383 },
];

export default class Game2 extends Scene {

    constructor() {
        super({ key: "Game2" });
    }
    init(data) {
        characterSelected = data.characterSelected;
        lastCoordenates = data.lastCoordenates;
        this.hasLightstick = false;
        speedEnemy = 120;
        redHeartsObject = [];
        blackHeartsObject = [];
        hearts = 1;
        this.events.off('buttonNext-dialogModal');
        this.startAll = false;
        setLastMovement('down');

    }

    preload() {
        if (this.sys.game.device.os.desktop) {
            console.log("desktop")
            this.isMobile = false;
        }
        else {
            this.isMobile = true;

            console.log("mobile")
        }
        cursors = this.input.keyboard.createCursorKeys();

    }

    create() {
        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        this.pauseButton = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.P);
        this.dialogModal = this.plugins.get('dialogModal');

        gameSettings = localStorage.getItem('sound');
        if (gameSettings === null) {
            localStorage.setItem('sound', 1);
            gameSettings = defaultSettings;
        }

        this.events.on('pause', () => {
            if(this.joystickManager) {
                this.joystickManager.pause();
            }

            this.startAll = false;
            this.ppalSong.pause();
        });

        this.events.on(`resume`, (data, args) => {
            this.sound.mute = false;
            if (args) {
                footsteps.stop();
                this.ppalSong.stop();
                this.scene.stop();
                if (args.goHome) {

                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }

                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Hallway`, { characterSelected: characterSelected, loadAgain: true, lastCoordenates });
                }

                if (args.goStart) {

                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }

                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Start`);
                }
            } else {
                if(!this.showingInstruction) {
                    this.startAll = true;
                }

                if(this.isMobile) {
                    if(this.joystickManager) {
                        this.joystickManager.show();
                    }
                }

                gameSettings = localStorage.getItem('sound');
                if (gameSettings === '0') {
                    if (this.ppalSong.isPlaying) {
                        this.ppalSong.stop()
                    }
                } else {
                    if (!this.ppalSong.isPlaying) {
                        this.ppalSong.play();
                    }
                }
            }
        });


        this.cameras.main.setBounds(0, 0, 3000);
        this.physics.world.setBounds(0, 0, 3000);

        this.ppalSong = this.sound.add(`goodnightSong`, { loop: true, volume: 0.2 });
        if (gameSettings === '1') {
            this.ppalSong.play();
        }
        const map = mapHandler(this, 'game2', true, 8, 8);

        footsteps = this.sound.add(`footsteps`, { loop: true, rate: 2, volume: 0.2 });

        this.playing = false;
        walls = map.walls;
        walls.setScale(3);
        map.ground.setScale(3);
        this.door = map.map.createLayer('Door', map.tileset, 0, 0);
        this.door.setCollisionByProperty({ collides: true });
        this.door.setScale(3);

        this.lightstick = map.map.createLayer('Lightstick', map.tileset, 0, 0);
        this.lightstick.setScale(3);

        this.object = map.map.createLayer('Objects', map.tileset, 0, 0);
        this.object.setCollisionByProperty({ collides: true });

        this.object.setScale(3);

        objNames[characterSelected] = this.physics.add.sprite(447, 984, `${characterSelected}-game2`, 4);
        objNames[characterSelected].setScale(2.5);
        objNames[characterSelected].setImmovable();

        const itemRandom = randomPointsEnemy[Math.floor(Math.random() * randomPointsEnemy.length)];

        this.enemy = this.physics.add.sprite(itemRandom.x, itemRandom.y, `enemy-game2`);
        this.enemy.setImmovable();
        this.enemy.setScale(2.5);


        this.deadSprite = this.physics.add.sprite(1622, 2051, `humo-game2`).setScale(2.5).setVisible(false);
        this.anims.create({
            key: `deadSpriteAnimation`,
            frames: this.anims.generateFrameNumbers('humo-game2', { start: 0, end: 16 }),
            frameRate: 7,
            repeat: -1
        });

        walkAnimation(this, `${characterSelected}-game2`);
        reposeAnimation(this, `${characterSelected}-game2`);
        turnStaticAnimation(this, `${characterSelected}-game2`);
        upStaticAnimation(this, `${characterSelected}-game2`);
        leftStaticAnimation(this, `${characterSelected}-game2`);
        rightStaticAnimation(this, `${characterSelected}-game2`);
        backStaticAnimation(this, `${characterSelected}-game2`);
        lightstickAnimation(this, `${characterSelected}-game2`);


        walkAnimation(this, `enemy-game2`);
        reposeAnimation(this, `enemy-game2`);
        turnStaticAnimation(this, `enemy-game2`);
        upStaticAnimation(this, `enemy-game2`);
        leftStaticAnimation(this, `enemy-game2`);
        rightStaticAnimation(this, `enemy-game2`);
        backStaticAnimation(this, `enemy-game2`);


        this.physics.add.collider(objNames[characterSelected], walls);
        this.physics.add.collider(this.enemy, walls, () => {
            randomDirection(`enemy-game2`);
        }, null, this);
        this.physics.add.collider(this.enemy, this.object, () => {
            randomDirection(`enemy-game2`);
        }, null, this);
        this.physics.add.collider(this.enemy, this.door, () => {
            randomDirection(`enemy-game2`);
        }, null, this);
        this.physics.add.collider(this.enemy, objNames[characterSelected], () => {

            this.deadSprite.setPosition(objNames[characterSelected].x, objNames[characterSelected].y);
            this.deadSprite.visible = true;
            this.deadSprite.anims.play(`deadSpriteAnimation`, true);
            this.enemy.destroy();
            objNames[characterSelected].setVelocity(0, 0);
            this.startAll = false;
            objNames[characterSelected].alpha = 0.5;
            objNames[characterSelected].setTint(0xff0000);

            clearTimeout(this.timeoutColliderEnemy);
            this.timeoutColliderEnemy = setTimeout(() => {

                this.tweens.add({
                    targets: redHeartsObject[hearts - 1],
                    alpha: 0,
                    scaleX: 0,
                    scaleY: 0,
                    ease: 'Linear',
                    duration: 200
                });

                var heartsTimeline = this.tweens.createTimeline();

                heartsTimeline.add({
                    targets: blackHeartsObject[hearts - 1],
                    scaleX: 1.5,
                    scaleY: 1.5,
                    ease: 'Power1',
                    duration: 200
                });

                heartsTimeline.add({
                    targets: blackHeartsObject[hearts - 1],
                    scaleX: 3,
                    scaleY: 3,
                    ease: 'Power1',
                    duration: 200
                });
                heartsTimeline.play();
                hearts -= 1;

                if (hearts > 0) {
                    randomDirection(`enemy-game2`);
                } else {
                    this.enemy.active = false;
                    this.enemy.visible = false;
                }

                setTimeout(() => {
                    if (hearts <= 0) {

                        if(this.joystickManager) {
                            this.joystickManager.destroyTest();
                        }

                        this.enemy.destroy();

                        this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                            if (progress === 1) {
                                footsteps.stop();
                                this.ppalSong.stop();
                                this.scene.stop();
                                this.events.off('buttonNext-dialogModal');

                                this.scene.start(`GameOver`, { characterSelected: characterSelected, level: 2, lastCoordenates });
                            }
                        });
                    }

                    objNames[characterSelected].clearTint();
                    objNames[characterSelected].alpha = 1;

                }, 1000);

            }, 500);

        }, null, this);

        this.physics.add.collider(objNames[characterSelected], this.object);
        this.physics.add.collider(this.enemy, this.object);
        this.physics.add.collider(objNames[characterSelected], this.door, () => {
            clearTimeout(timeoutDoor);
            timeoutDoor = setTimeout(() => {
                if (this.hasLightstick) {
                    let total = JSON.parse(localStorage.getItem('noL'));
                    if (total) {
                        if (!total.includes(2)) {
                            total.push(2);
                            localStorage.setItem('noL', JSON.stringify(total));

                        }
                    } else {
                        localStorage.setItem('noL', JSON.stringify([2]));
                    }

                    this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                        if (progress === 1) {
                            footsteps.stop();
                            this.ppalSong.stop();
                            this.scene.stop();
                            if(this.joystickManager) {
                                this.joystickManager.destroyTest();
                                this.joystickManager = null;
                            }
                            this.events.off('buttonNext-dialogModal');

                            this.scene.start(`Win`, { characterSelected: characterSelected, level: 2, lastCoordenates });
                        }
                    });


                }
            }, 1000);
        }, null, this);

        this.time.addEvent({
            delay: 10000,
            callback: () => {
                if (speedEnemy < 500) {
                    speedEnemy += 20;
                }
            },
            loop: true
        })

        this.cameras.main.startFollow(objNames[characterSelected], true);

        this.buttonFullscreen = new FullScreen(this);
        this.buttonSettings = new SettingsButton(this);
        this.buttonPause = new PauseButton(this, characterSelected);
        this.buttonHelp = new HelpButton(this);


        window.addEventListener("blur", () => {
            this.buttonPause.pauseByEvent();
         });
     
        //  document.addEventListener('visibilitychange', () => {
        //      if (document.visibilityState !== 'visible') {
        //          this.buttonPause.pauseByEvent();
        //  } 
        //  });

        this.events.on('buttonNext-dialogModal', (data) => {
            instructionsHandler++;
            if (data.id === 'start-text') {
                if (instructionsHandler === 1) {
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    this.startAll = true;
                    this.showingInstruction = false;

                    if(this.isMobile) {
                        this.joystickManager = new Joystick(objNames[characterSelected], `${characterSelected}-game2`, 300);
                        this.joystickManager.createJoystick();
                        this.joystickManager.activate(this.hasLightstick);

                    }
                }
            }

            if (data.id === 'finish-text') {
                if (instructionsHandler === 1) {
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    this.startAll = true;
                    this.showingInstruction = false;
                }
            }
        })

        objNames[characterSelected].anims.play(`repose-${characterSelected}-game2`);
        this.dialogModal._createImageDialog(this, 'start-text');
        this.showingInstruction = true;

        this.dialogModal.setText("The door is broken, \nI think someone broke it with that axe on the floor... \nI need to be careful if the person who \nbroke the door is still around...", `${characterSelected}-hallway`, false, false);

        if (this.isMobile) {
            this.buttonAction = new ButtonPressed(this, 700, 500 - 51, `buttonAction`);
            this.buttonAction.setScale(2);
            this.add.existing(this.buttonAction);
        }

        let x = 0;
        let y = 16;
        for (let i = 0; i < totalHearts; i++) {
            if (i === 0) {
                x += 40;
            } else {
                x += 30;
            }
            blackHeartsObject.push(this.add.image(x, y, `heartBlack`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
            redHeartsObject.push(this.add.image(x, y, `heartRed`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
        }

        this.lightstickCounter = new LightstickCounter(this);
        this.helpLightstick = this.add.bitmapText(0, 20, 
            'pixelfont', "Interact: spacebar/action button".toUpperCase(), 10,1).setTint(0xffffff).setOrigin(1, 0).setScale(1).setVisible(false).setScrollFactor(0);

        this.screenCenterX = (this.cameras.main.worldView.x + this.cameras.main.width / 2) + 90;
        this.screenCenterY = this.cameras.main.worldView.y;


    }
    update() {


        if (this.startAll) {
            if (!this.isMobile) {
                walkHandler(cursors, objNames[characterSelected], 300, `${characterSelected}-game2`, this.hasLightstick);
            } else {
                if(this.joystickManager) {

                    this.joystickManager.show();
                }
            }

            const tile = this.lightstick.getTileAtWorldXY(objNames[characterSelected].x, objNames[characterSelected].y);
            if (tile) {
                if (this.lightstick.visible) {
                    this.helpLightstick.setPosition(this.screenCenterX + 30, this.screenCenterY + 30);
                    this.helpLightstick.visible = true;

                    if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                        this.startAll = false;
                        this.lightstick.visible = false;
                        this.hasLightstick = true;
                        if(this.isMobile) {
                            this.joystickManager.setLightStickValue(this.hasLightstick);
                        }
                        this.showingInstruction = true;
                        this.dialogModal._createImageDialog(this, 'finish-text');

                        this.dialogModal.setText("Got it! \nIt was trapped inside the mirror. \nI need to go back to the exit.", `${characterSelected}-hallway`, false, true)
                        setTimeout(() => {
                            this.dialogLightstickVisible = true;
                        }, 1000);
                    }
                }
            } else {
                this.helpLightstick.visible = false;
            }

            if ((!this.isMobile && (cursors.left.isDown || cursors.right.isDown || cursors.up.isDown || cursors.down.isDown))) {
                if (this.playing !== true) {
                    if (gameSettings === '1') {

                        footsteps.play();
                        this.playing = true;
                    }
                }

            } else {
                this.playing = false;
                footsteps.stop();
            }

            if (this.enemy.active) {

                const angles = MathPhaser.Angle.BetweenPoints(this.enemy, objNames[characterSelected])
                const newAngles = MathPhaser.RadToDeg(angles);

                if (this.enemy.body.speed > 0) {
                    if (newAngles <= -45 && newAngles >= -135) {
                        this.enemy.anims.play(`up-enemy-game2`, true);
                    } else if (newAngles <= 45 && newAngles >= -45) {
                        this.enemy.flipX = true
                        this.enemy.anims.play(`left-enemy-game2`, true);
                    } else if (newAngles <= 135 && newAngles >= 45) {
                        this.enemy.anims.play(`down-enemy-game2`, true);
                    } else if (newAngles <= 225 && newAngles >= 135) {
                        this.enemy.flipX = true
                        this.enemy.anims.play(`right-enemy-game2`, true);
                    }

                }

                this._enemyFollows();

            }
        } else {
            if(this.isMobile) {
                if(this.joystickManager) {
                    objNames[characterSelected].setVelocity(0, 0);
                    objNames[characterSelected].anims.play(`repose-${characterSelected}-game2`);
                    this.joystickManager.pause();
                }
            }
        }

        // if (!this.isMobile && this.pauseButton.isDown) {

        //     this.scene.launch('Pause', { scene: 'Game2' });
        //     this.scene.pause();

        // }

    }

    _enemyFollows() {
        this.physics.moveToObject(this.enemy, objNames[characterSelected], 100);
    }

}